import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { useLoader } from "../../../utils/common";

const API_URL = "/admin/about-us/gallery";

// new file wins over the stored image
const Preview = ({ file, current, base }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (file && file.length) {
      const u = URL.createObjectURL(file[0]);
      setUrl(u);
      return () => URL.revokeObjectURL(u);
    }
    setUrl("");
  }, [file]);
  const src = url || (current ? base + current : "");
  if (!src) return null;
  return <img src={src} alt="Preview" className="image-preview mt-2" style={{ maxWidth: 160, maxHeight: 130 }} />;
};

const Edit = ({ id, handleClose }) => {
  const { getData, IMG_URL } = useContext(Context);
  const { withLoader } = useLoader();
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [existingImage, setExistingImage] = useState("");
  const [existingVideo, setExistingVideo] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues: { media_type: "image" } });

  const mediaType = watch("media_type");

  useEffect(() => {
    (async () => {
      const response = await withLoader(() => getData(`${API_URL}/${id}`));
      const d = { ...(response?.data || {}) };
      setExistingImage(d.image || "");
      setExistingVideo(d.video || "");
      delete d.image; // the file inputs only carry newly picked files
      delete d.video;
      reset(d);
    })();
    // eslint-disable-next-line
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("category", data.category);
      sendData.append("media_type", data.media_type);
      sendData.append("caption", data.caption || "");
      sendData.append("description", data.description || "");
      sendData.append("link", data.link || "");
      sendData.append("sort_order", data.sort_order || 0);
      // only send files that were newly picked; otherwise the stored ones stay
      if (data.image && typeof data.image !== "string" && data.image.length) sendData.append("image", data.image[0]);
      if (data.video && typeof data.video !== "string" && data.video.length) sendData.append("video", data.video[0]);

      const response = await withLoader(() => putData(`${API_URL}/${id}`, sendData));
      setShowModal({ code: response?.code, message: response?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (response?.success) handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        show
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Edit Gallery Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row className="justify-content-center">
              <Col md={4}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Shown in</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        as="select"
                        className={classNames("w-100", { "is-invalid": errors?.category })}
                        {...register("category", { required: "Select where it is shown" })}
                      >
                        <option value="">Select</option>
                        <option value="event">Gallery: store events</option>
                        <option value="social">Gallery: social media</option>
                        <option value="old_photo">Journey background (old photos)</option>
                      </Form.Control>
                    </InputGroup>
                    {errors.category && <span className="text-danger">{errors.category.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={4}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Media Type</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control as="select" className="w-100" {...register("media_type")}>
                        <option value="image">Image</option>
                        <option value="video">Video</option>
                      </Form.Control>
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={4}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Display Order</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="number" min={0} className="w-100" {...register("sort_order")} />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        maxLength={200}
                        placeholder="Short title (optional)"
                        className="w-100"
                        {...register("caption")}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Description (optional)"
                        className="w-100"
                        {...register("description")}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Link (optional)</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        maxLength={500}
                        placeholder="Social post or video link, e.g. https://www.instagram.com/p/..."
                        className={classNames("w-100", { "is-invalid": errors?.link })}
                        {...register("link", {
                          pattern: { value: /^https?:\/\/.+/i, message: "Link must start with http:// or https://" },
                        })}
                      />
                    </InputGroup>
                    <small className="text-muted">Clicking the item on the website opens this link.</small>
                    {errors.link && <div className="text-danger">{errors.link.message}</div>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>{mediaType === "video" ? "Video Cover Image (optional)" : "Image"}</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="file"
                        accept="image/*"
                        className={classNames("w-100", { "is-invalid": errors?.image })}
                        {...register("image", {
                          validate: (v) => {
                            if (mediaType !== "image" || existingImage) return true;
                            return (v && v.length > 0) || "Image is required";
                          },
                        })}
                      />
                    </InputGroup>
                    <small className="text-muted">Leave empty to keep the current image.</small>
                    {errors.image && <div className="text-danger">{errors.image.message}</div>}
                  </Form.Group>
                  <Preview file={watch("image")} current={existingImage} base={IMG_URL} />
                </div>
              </Col>

              {mediaType === "video" && (
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <Form.Label>Video File</Form.Label>
                      <InputGroup className="d-block">
                        <Form.Control
                          type="file"
                          accept="video/*"
                          className={classNames("w-100", { "is-invalid": errors?.video })}
                          {...register("video", {
                            validate: (v) => {
                              if (mediaType !== "video") return true;
                              const hasFile = (v && v.length > 0) || !!existingVideo;
                              const hasLink = (getValues("link") || "").trim().length > 0;
                              return hasFile || hasLink || "Add a video file or a video link";
                            },
                          })}
                        />
                      </InputGroup>
                      {existingVideo && (
                        <small className="d-block">
                          Current video:{" "}
                          <a href={IMG_URL + existingVideo} target="_blank" rel="noreferrer">
                            open
                          </a>
                          . Pick a file to replace it.
                        </small>
                      )}
                      {errors.video && <div className="text-danger">{errors.video.message}</div>}
                    </Form.Group>
                  </div>
                </Col>
              )}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton name={"Cancel"} handleClose={handleClose} />
                  </Link>
                  <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default Edit;